module.exports = __webpack_public_path__ + "static/media/door0401.ffdfad3f.jpg";